<template>
	<div class="pointsM">
		<Tou></Tou>
		<div class="w1500">

			<div class="pointsTop bj-0 br-20 flex j-between pt-56 pb-56 pl-45 pr-87 mt-43"
				style="box-shadow: -1px 0px 21px 1px rgba(0,0,0,0.05); ">
				<div class="points1_ll flex a-center">
					<el-image fit="contain" class="" :src="require('@/assets/pc/mall/mall1.png')" alt="" />
					<div class="tit-20 ml-10 mr-18" style="color: #666666;">
						<!-- My Points: -->
						{{gudingziduan.PointsMall.mypoints}}
						<span
							class="ys-33">{{myshu.pointNum}}</span> </div>
					<div class="buzhouann inline-block ys-0 pt-12 pb-12 pl-32 pr-32 br-20 mr-28 cur_pointer"
						@click="tiaogeren(1)">Points detail</div>
					<div class="tit-16 cur_pointer" style="color: #888888;" @click="$dakai('/coinAgreement')">How to
						redeem?</div>
				</div>
				<div class="points1_rr flex a-center">
					<div class="flex a-center mr-80" @click="tiaogeren(2)">
						<el-image fit="contain" class="" :src="require('@/assets/pc/mall/mall2.png')" alt="" />
						<span class="ml-14 tit-17 cur_pointer" style="color:#747474;">Shipping address</span>
					</div>
					<div class="flex a-center" @click="tiaogeren(3)">
						<el-image fit="contain" class="" :src="require('@/assets/pc/mall/mall3.png')" alt="" />
						<span class="ml-14 tit-17 cur_pointer" style="color:#747474;">My order</span>
					</div>
				</div>
			</div>

			<div class="flex a-center points2 mt-80 mb-51">
				<div class="f-42 B-700 tit1">Gift Card</div>
				<div class="flex a-center numEnter">
					<span class="tit2 tit-16 ml-40 mr-23" style="color: #717171;">Points Range:</span>
					<el-input class="mr-14" v-model="so.min" placeholder="min:"></el-input>
					<el-input class="mr-14" v-model="so.max" placeholder="max:"></el-input>
					<div class="cur_pointer buzhouann inline-block ys-0 pt-10 pb-10 pl-20 pr-20 br-20"
						@click="soPoints(1)">Search</div>
				</div>
			</div>
			<div class="lieb flex flex-wrap j-between" v-if="myshu.isPlus==false">
				<div class="bj-0 br-10  liebs" style="overflow: hidden;" v-for="(c,index) in ciftlie">
					<el-image class="el-image1" fit="fill" :src="c.image" alt="" />
					<div class="pl-30 pr-30 pt-34 pb-34">
						<div class="tit-20 B-700 mb-20" style="white-space: nowrap;overflow: hidden;">
							{{c.commodityName}}</div>
						<div class="flex a-center mb-35">
							<el-image fit="contain" class="el-image2" :src="require('@/assets/pc/mall/mall4.png')"
								alt="" />
							<span class="ml-10 tit-22 B-700" style="color: #E71118;">{{c.needIntegral}}</span>
						</div>
						<div class="redeem tit-18 flex a-center j-center" @click="Duihuan(c)">
							<!-- Redeem -->
							{{gudingziduan.PointsMall.Redeem}}
						</div>
					</div>
				</div>
			</div>
			<div class="flex a-center points2 mt-80 mb-51">
				<div class="f-42 B-700 tit1">Entity</div>
				<div class="flex a-center numEnter">
					<span class="tit2 tit-16 ml-40 mr-23" style="color: #717171;">Points Range:</span>
					<el-input class="mr-14" v-model="so.min2" placeholder="min:"></el-input>
					<el-input class="mr-14" v-model="so.max2" placeholder="max:"></el-input>
					<div class="buzhouann inline-block ys-0 pt-10 pb-10 pl-20 pr-20 br-20 cur_pointer"
						@click="soPoints(2)">Search</div>
				</div>
			</div>
			<div class="lieb flex flex-wrap j-between"  v-if="!weidenglu">
				<div class="bj-0 br-10 liebs" style="overflow: hidden;" v-for="(c,index) in Entitylie">
					<el-image class="el-image1" fit="fill" :src="c.image" alt="" />
					<div class="pl-30 pr-30 pt-34 pb-34">
						<div class="tit-20 B-700 mb-20" style="white-space: nowrap;overflow: hidden;">
							{{c.commodityName}}</div>
						<div class="flex a-center mb-35">
							<el-image fit="contain" class="el-image2" :src="require('@/assets/pc/mall/mall4.png')"
								alt="" />
							<span class="ml-10 tit-22 B-700" style="color: #E71118;">{{c.needIntegral}}</span>
						</div>
						<div class="redeem tit-18 flex a-center j-center cur_pointer" @click="Duihuan(c,1)"> 
							<!-- Redeem -->
							{{gudingziduan.PointsMall.Redeem}}
						</div>
					</div>
				</div>
			</div>
			<div class="flex a-center points2 mt-80 mb-51">
				<div class="f-42 B-700 tit1">
					<!-- Extended warranty -->
					{{gudingziduan.PointsMall.Extendedwarranty}}
					
				</div>
				<!-- 	<div class="flex a-center numEnter">
					<span class="tit2 tit-16 ml-40 mr-23" style="color: #717171;">Points Range:</span>
					<el-input class="mr-14" v-model="so.min3" placeholder="min:"></el-input>
					<el-input class="mr-14" v-model="so.max3" placeholder="max:"></el-input>
					<div class="buzhouann inline-block ys-0 pt-10 pb-10 pl-20 pr-20 br-20 cur_pointer"
						@click="soPoints(3)">Search</div>
				</div> -->
			</div>
			<div class="warrantylie">
				<div v-if="yy=='PK' && weidenglu!=true" class="bj-0 br-10  liebs " style=""   @click="duihuanyanbao(1)">
					<el-image class="el-image1" fit="fill" alt="" :src="require('@/assets/pc/prom/banner.jpg')"/>
				</div>
				<!-- &&  pluslenve>0 -->
				
				<div  class="bj-0 br-10  liebs " style="" v-if="yy!='PK' && weidenglu==false" v-for="(c,index) in Extelie" @click="duihuanyanbao()">
					<el-image class="el-image1" fit="fill"  :src="c.image" />
				</div>
			</div>
		</div>


		<div>
			<StayTact></StayTact>
		</div>

		<Foot></Foot>
	</div>
</template>

<script>
	import Tou from '../../../zuzuzu/touss.vue'
	import StayTact from '../../../components/StayTact.vue'
	import Foot from '../../../zuzuzu/foot.vue'
	import {
		myxiangqing
	} from '@/api/Personal.js';
	import {
		Giftcards,
		CommodityPlus,
		lpkduihuan,
		pluslpkduihuan
	} from '@/api/PointsMall.js';
	import {
		allUser
	} from '@/api/user.js';
	export default {
		data() {
			return {
				min: '',
				max: '',
				mail: {},
				so: {
					max: '',
					min: '',
					max2: '',
					min2: '',
					max3: '',
					min3: ''
				},
				ciftlie: [], //礼品卡列，
				Entitylie: [], //实物商品列，
				Extelie: [],
				myshu: {
					pointNum: 0
				},
				gudingziduan:{},
				weidenglu: false,
				yy:'',
				pluslenve:0
			}
		},
		watch: {
		    '$store.state.cunyuanyan': {
		      handler(newValue, oldValue) {
		        // console.log('语言已更新:', newValue);
		        this.gudingziduan=this.$store.state.cunyuanyan
				this.yy=this.$store.state.yuyan
				console.log(this.yy)
		      },
		      deep: true // 如果 cunyuanyan 是对象，需要设置 deep 为 true
		    }
		},
		created() {
			this.$store.commit('Gaiyuyan', this.$store.state.yuyan);
			this.gudingziduan=this.$store.state.cunyuanyan
			this.yy=this.$store.state.yuyan
			// console.log(this.gudingziduan,'video')
			this.$cun('Tindex', 3)
	
			
			allUser().then(s => {
				if (s.code == 200) {
					this.myshu = s.data
					this.wodexiangqing()
					this.weidenglu = false
				} else {
					this.weidenglu = true
					// this.$confirm(s.message).then(_ => {this.$dakai('login_in') })
					// this.$dakai('login_in')
				}
			})
			this.lika()
			this.shiwuka()
			this.weixiuka()


		},
		components: {
			Tou,
			StayTact,
			Foot,
		},
		methods: {
			wodexiangqing() {
				myxiangqing().then(res => {
					console.log(res, 1111)
					if (res.data) {
						this.pluslenve = res.data.plusLevel
					}
			
				})
			},
			send() {},
			lika() {
				// 礼品卡
				Giftcards({
					max: this.so.max,
					min: this.so.min,
					gift: '',
					address: '',
					type: '2'
				}).then(shu => {
					this.ciftlie = shu.data
				})
			},
			duihuanyanbao(e) {
				if (this.weidenglu == true) {
					// this.$message({
					// 	showClose: true,
					// 	iconClass: 'el-icon-warning',
					// 	customClass: 'my-error-message',
					// 	dangerouslyUseHTMLString: true,
					// 	message:'<strong><i style="margin-left:.1rem;">Please log in first</i> <a href="https://community.goodwe.com/login_in" style="color:red;margin-left:4px;text-decoration: none;">[here]</i> </strong>',
					// 	type: 'error',
					// 	offset: '350',
					// 	duration: 0
					// });
					this.$alert('Please log in first', '', {
					  confirmButtonText: 'Log in',
					  confirmButtonClass:'Loginanniu',
					  distinguishCancelAndClose:true,
					  center:true,
					  roundButton:true,
					  callback: action => {
						  if(action=='confirm'){
								this.$dakai('/login_in')
						  }
					  }
					});
					// this.$dakai('login_in')
					
				} else {
					if(e){
						window.open(`https://sasea-10-years-warranty-promotion-81304.gr-site.com/`, '_blank');
					}else{
						if (this.myshu.plusLevel >= 1) {
							// this.$dakai('warranty')
							this.$router.push({name: "warranty"})
						} else {
							this.$message({
								showClose: true,
								iconClass: 'el-icon-warning',
								customClass: 'my-error-message',
								message: 'Available for GoodWe PLUS+ Silver and Gold Installers only.',
								type: 'error',
								offset: '350',
								duration: 0
							});
						}
						
					}
				}
			},
			shiwuka() {
				// 商品实物
				Giftcards({
					max: this.so.max2,
					min: this.so.min2,
					gift: '',
					address: '',
					type: '3'
				}).then(shu => {
					this.Entitylie = shu.data
				})
			},
			weixiuka() {
				// 商品实物
				this.Extelie=[]
				Giftcards({
					max: this.so.max3,
					min: this.so.min3,
					gift: '',
					address: '',
					type: '4'
				}).then(shu => {
					this.Extelie = shu.data
				})
			},
			tiaogeren(e) {
				if (this.weidenglu) {
					// this.$message({
					// 	showClose: true,
					// 	iconClass: 'el-icon-warning',
					// 	customClass: 'my-error-message',
					// 	dangerouslyUseHTMLString: true,
					// 	message:'<strong><i style="margin-left:.1rem;">Please log in first</i> <a href="https://community.goodwe.com/login_in" style="color:red;margin-left:4px;text-decoration: none;">[here]</i> </strong>',
					// 	type: 'error',
					// 	offset: '350',
					// 	duration: 0
					// });
					this.$alert('Please log in first', '', {
					  confirmButtonText: 'Log in',
					  confirmButtonClass:'Loginanniu',
					  distinguishCancelAndClose:true,
					  center:true,
					  roundButton:true,
					  callback: action => {
						  if(action=='confirm'){
								this.$dakai('/login_in')
						  }
					  }
					});
					this.$dakai('login_in')
				} else {
					if (e == 1) {
						this.$dakai('/user-Profile?type=4')
						
					} else if (e == 2) {
						// this.$dakai('/address')
						this.$router.push({name: "address"})
					} else if (e == 3) {
						// this.$dakai('/myOrder')
						this.$router.push({name: "myOrder"})
					}
				}
			},
			soPoints(w) {
				if (w == 1) {
					this.lika()
				} else if (w == 2) {
					this.shiwuka()
				} else {
					this.weixiuka()
				}
			},
			Duihuan(e, k) {
				if (this.weidenglu == true) {
					// this.$dakai('login_in')
					// this.$message({
					//   showClose: true,
					//   iconClass:'el-icon-warning',
					//   customClass:'my-error-message',
					//  dangerouslyUseHTMLString: true,
					//  message:'<strong><i style="margin-left:.1rem;">Please log in first</i> <a href="https://community.goodwe.com/login_in" style="color:red;margin-left:4px;text-decoration: none;">[here]</i> </strong>',
					//   type: 'error',
					//   offset:'350',
					//   duration:0,
					//   iconClass:'el-icon-warning'
					// });
					this.$alert('Please log in first', '', {
					  confirmButtonText: 'Log in',
					  confirmButtonClass:'Loginanniu',
					  distinguishCancelAndClose:true,
					  center:true,
					  roundButton:true,
					  callback: action => {
						  if(action=='confirm'){
								this.$dakai('/login_in')
						  }
					  }
					});
				} else {
					// this.myshu.plusLevel < e.plus && 
					console.log('this.yy='+this.yy)
					if (this.myshu.plusLevel < 1 && k == 1 && this.yy!='PK') {
						this.$message({
							showClose: true,
							iconClass: 'el-icon-warning',
							customClass: 'my-error-message',
							message: 'Available for GoodWe PLUS+ Silver and Gold Installers only.',
							type: 'error',
							offset: '350',
							duration: 0
						});
					} else {
						if(this.myshu.pointNum<e.needIntegral){
							this.$message({
								showClose: true,
								iconClass: 'el-icon-warning',
								customClass: 'my-error-message',
								message: 'Insufficient balance to redeem.',
								type: 'error',
								offset: '350',
								duration: 0
							});
						}else if(this.myshu.pointNum>=e.needIntegral){
							if (e.type == 2) {
								if(this.myshu.isPlus){
									pluslpkduihuan({
										'id': e.id
									}).then(s => {
										if (s.code > 200) {
											this.$message({
												showClose: true,
												iconClass: 'el-icon-warning',
												customClass: 'my-error-message',
												message: s.message,
												type: 'error',
												offset: '350',
												duration: 0
											});
										} else {
											this.$message({
												showClose: true,
												message: s.message,
												type: 'success',
												offset: '350',
												duration: 0
											});
											// this.$dakai('/results?id=' + e.id)
											this.$router.push({name: "results",params:{id:e.id}})
										}
									})
								}else{
									lpkduihuan({
										'id': e.id
									}).then(s => {
										if (s.code > 200) {
											this.$message({
												showClose: true,
												iconClass: 'el-icon-warning',
												customClass: 'my-error-message',
												message: s.message,
												type: 'error',
												offset: '350',
												duration: 0
											});
										} else {
											this.$message({
												showClose: true,
												message: s.message,
												type: 'success',
												offset: '350',
												duration: 0
											});
											// this.$dakai('/results?id=' + e.id)
											this.$router.push({name: "results",params:{id:e.id}})
										}
									})
									
								}
							} else {
								// this.$dakai('/exchange?id=' + e.id)
								this.$router.push({name: "exchange",params:{id:e.id}})
							}
						}
						
					}
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.pointsM {
		.buzhouann {
			background: linear-gradient(87deg, #ff785c 0%, #e70a16 100%);
			border-radius: 100px;
		}

		.points1_ll {
			::v-deep .el-image {
				width: .49rem;
				height: .49rem;
			}
		}

		.points1_rr {
			::v-deep .el-image {
				width: .28rem;
				height: .28rem;
			}
		}

		.points2 {
			::v-deep .el-input {
				width: 1.46rem;
				min-width: 80px;
				height: .37rem;
				min-height: 30px;
			}

			::v-deep .el-input input {
				height: 100%;
				line-height: initial;
			}

			::v-deep .el-input__inner {
				background-color: transparent;
				border: 1px solid #D9D9D9 !important;
			}

			::v-deep ::-webkit-input-placeholder {
				color: #717171;
				font-size: .16rem;
			}
		}

		.warrantylie {
			width: 100%;
			border-radius: 14px;
			margin-bottom: .5rem;
			transition: all 0.5s;

			.liebs {
				margin-top: .3rem;
				width: 100%;
				// height:3.3rem;
				border-radius: 14px;
				padding: 16px;
				box-sizing: border-box;
				border: 1px solid #c1c1c1;
				transition: transform 0.5s ease;
				/* 添加平滑过渡 */
			}

			/* 鼠标悬停效果 */
			.liebs:hover {
				transform: translateY(-10px);
				/* 移动确实为30px */
			}

			// .liebs :hover{
			::v-deep .el-image1 {
				height: 3.3rem;
				width: 100%;
			}
		}

		.lieb {
			display: grid;
			grid-template-columns: repeat(4, 1fr);
			gap: .3rem;

			::v-deep .el-image1 {
				// height: 1.89rem;
				width: 100%;
			}

			::v-deep .el-image1 img {
				display: block;
				width: 100%;
			}

			::v-deep .el-image2 {
				width: .26rem;
				height: .26rem;
			}

			.redeem {
				width: 100%;
				height: .55rem;
				border: 2px solid #f8f4f2;
				border-radius: .1rem;
				color: #A1A1A1;
				transition: .4s;
				cursor: pointer;
			}

			.redeem:hover {
				background: #e70a16;
				color: #fff;
				border-color: #e70a16;
			}
		}

		.indexStay .STAY {
			background: url('../../../assets/pc/logo22.jpg');
			background-size: 100% 100% !important;
			width: 100%;
			height: 3.3rem;
			box-sizing: border-box;

			.tle {
				font-family: "montserBold";
			}

			.STAY-sign {
				width: 34%;
				height: .68rem;
				border-radius: 34px;
				margin-top: .6rem;
				overflow: hidden;

				::v-deep .btn {
					// width: 29%;
					height: .68rem;
					border-radius: 34px;
					line-height: .68rem;
					padding: 0;
					display: inline-block;
					padding: 0 .61rem;
				}

				::v-deep .el-input__inner {
					height: .68rem;
					line-height: .68rem;
					padding-left: .47rem;
				}
			}
		}
	}

	.pointsTop {
		flex-wrap: wrap;
	}

	.pointsTop .points1_ll {
		flex-wrap: wrap;
	}

	.pointsTop .points1_rr {
		margin-top: .1rem;
	}

	.pointsM .points2 {
		flex-wrap: wrap;
	}


	// ==========================================================================================================================================================================
	// 响应式
	@media screen and (max-width: 1024px) {
		.pointsM .lieb {
			grid-template-columns: repeat(3, 1fr);
		}
	}

	@media screen and (max-width: 767px) {
		.points2 .numEnter {
			flex-wrap: wrap;
			margin-top: .2rem;
		}

		.points2 .numEnter .tit2 {
			margin-left: 0;
		}

		.pointsM .lieb {
			grid-template-columns: repeat(2, 1fr);
		}
	}
</style>